import { EmployeesService } from '../../../services/employees.service';
import * as moment from 'moment';
import * as _ from "lodash";
import { IEmployeeAvailability } from '../../../services/employeeAvailability.service';

class AvailabilityListController implements ng.IComponentController {
    private startDate: any;
    private endDate: any;
    private availabilities: IEmployeeAvailability[];

    constructor(
        private $state: ng.ui.IStateService,
        private EmployeesService: EmployeesService    
    ) {
        'ngInject';
    }

    public $onInit = () => {
        var date = moment();
        this.startDate = date.format("YYYY-MM-DD");
        this.endDate = date.add(1, 'M').format("YYYY-MM-DD");
        this.getAvailabilityByDate();
    }

    private prevWeek = () => {
        this.startDate = moment(this.startDate).add(-7, 'day').toDate();
        this.endDate = moment(this.endDate).add(-7, 'day').toDate();
    }

    private nextWeek = () => {
        this.startDate = moment(this.startDate).add(7, 'day').toDate();
        this.endDate = moment(this.endDate).add(7, 'day').toDate();
    }

    public getAvailabilityByDate() {
        this.EmployeesService.getAvailabilityByRange(this.startDate, this.endDate).then((result) => {
            result.forEach(a => {
                a.startDate = moment(a.start);
            });
            result = _.sortBy(result, 'startDate');
            this.availabilities = result;
        });
    }
}

export const availabilityListComponent = {
    bindings: {
        avalabilityStatuses: '<'
    },
    controller: AvailabilityListController,
    template: require('./availabilityList.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/hr/availabilityList/availabilityList.component.ts